export const UsingRegexp = /^([A-Za-z0-9_-]+),([A-Za-z0-9_-]+)$/;
export const ManyToManyFieldPrefix = '@@ra-many-to-many/';
